import { FIELDS } from 'modules/cm/domain/Case/Applicant/Income/Future/Future';
import { FormModel } from './types';

export const FormFields: Record<keyof FormModel, any> = {
  [FIELDS.MINIMUM_RETIRED_INCOME]: {
    name: FIELDS.MINIMUM_RETIRED_INCOME,
    label: 'Retired income total',
  },
  [FIELDS.FUTURE_INCOME_PENSION]: {
    name: FIELDS.FUTURE_INCOME_PENSION,
    label: 'Pension Total',
  },
  [FIELDS.FUTURE_INCOME_TOTAL]: {
    name: FIELDS.FUTURE_INCOME_TOTAL,
    label: 'Total',
  },
  [FIELDS.EMPLOYED_ANTICIPATED_GROSS_ANNUAL_INCOME]: {
    name: FIELDS.EMPLOYED_ANTICIPATED_GROSS_ANNUAL_INCOME,
    label: 'Anticipated gross annual income',
  },
  [FIELDS.EMPLOYED_ANTICIPATED_RETIREMENT_DATE]: {
    name: FIELDS.EMPLOYED_ANTICIPATED_RETIREMENT_DATE,
    label: 'Anticipated retirement date plausibility',
  },
  [FIELDS.SELF_EMPLOYED_ANTICIPATED_GROSS_ANNUAL_INCOME]: {
    name: FIELDS.SELF_EMPLOYED_ANTICIPATED_GROSS_ANNUAL_INCOME,
    label: 'Anticipated gross annual income',
  },
  [FIELDS.SELF_EMPLOYED_ANTICIPATED_RETIREMENT_DATE]: {
    name: FIELDS.SELF_EMPLOYED_ANTICIPATED_RETIREMENT_DATE,
    label: 'Anticipated retirement date plausibility',
  },
  [FIELDS.MINIMUM_TAXABLE_RETIRED_INCOME]: {
    name: FIELDS.MINIMUM_TAXABLE_RETIRED_INCOME,
    label: 'Minimum taxable retired income (Empl, Self-empl, Investment, Rental etc)',
  },
  [FIELDS.HAS_TAXABLE_RETIRED_INCOME_CONTINUING]: {
    name: FIELDS.HAS_TAXABLE_RETIRED_INCOME_CONTINUING,
    label: 'Income continuing',
  },
  [FIELDS.MINIMUM_TAX_FREE_RETIRED_INCOME]: {
    name: FIELDS.MINIMUM_TAX_FREE_RETIRED_INCOME,
    label: 'Minimum tax-free retired income (Benefits & Maintenance)',
  },
  [FIELDS.HAS_TAX_FREE_RETIRED_INCOME_CONTINUING]: {
    name: FIELDS.HAS_TAX_FREE_RETIRED_INCOME_CONTINUING,
    label: 'Income continuing',
  },
  [FIELDS.OTHER_INCOME_ANTICIPATED_GROSS_ANNUAL_INCOME]: {
    name: FIELDS.OTHER_INCOME_ANTICIPATED_GROSS_ANNUAL_INCOME,
    label: 'Anticipated gross annual income',
  },
  [FIELDS.OTHER_INCOME_DETAILS]: {
    name: FIELDS.OTHER_INCOME_DETAILS,
    label: 'Anticipated retirement date plausibility',
  },
  [FIELDS.MINIMUM_TAXABLE_RETIRED_INCOME_DETAILS]: {
    name: FIELDS.MINIMUM_TAXABLE_RETIRED_INCOME_DETAILS,
    label: 'Description',
  },
  [FIELDS.MINIMUM_TAX_FREE_RETIRED_INCOME_DETAILS]: {
    name: FIELDS.MINIMUM_TAX_FREE_RETIRED_INCOME_DETAILS,
    label: 'Description',
  },
};
